import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthService } from '@portal-core/auth/services/auth.service';
import { BrowserHostService } from '@portal-core/auth/services/browser-host.service';
import { map, Observable, of, switchMap, tap } from 'rxjs';

/**
 * Checks the browser host (Flare) version to determine if multiple backend Central instances are supported.
 */
export const browserHostVersionGuard: CanActivateFn = (): Observable<boolean> => {
  const browserHostService = inject(BrowserHostService);
  const authService = inject(AuthService);

  // If the browser host is defined then run the code to check the browser host version
  if (browserHostService.isCefSharpHosted()) {
    return browserHostService.browserHost$().pipe(
      switchMap(browserHost => browserHost?.version?.() ?? of(-1)),
      tap(version => {
        // enable multiple Central instances if browser host version greater than or equal to two
        authService.supportsMultipleCentralInstances = version >= 2;
      }),
      map(() => true)
    );
  }

  return of(true);
};
